import { useAuthenticatedQuery } from "@l2r-front/l2r-auth"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { ModulesInfo } from "../../constants/modules"

import { documentQueryKeys } from "./queryKeys"

export function useElementTypeQuery(elementType, elementTypeCode, config = {}) {
    const baseUrl = ModulesInfo?.[elementType]?.typeUrl
    const url = `${baseUrl}/${elementTypeCode}/`
    const queryKey = documentQueryKeys.elementType(elementTypeCode)

    const { enabled = true } = config
    const { selectedNetwork } = useNetworksStateContext()
    queryKey.push({ network: selectedNetwork?.slug })

    return useAuthenticatedQuery(
        url,
        queryKey,
        { project: selectedNetwork?.slug },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled && !!elementType,
        },
    )
}